/**
 * Tabs Block Functionality
 *
 * Handles tab navigation and content switching for the tabs block.
 *
 * @package Karuna_Hospice
 */

/**
 * Initialize tabs functionality
 */
export function initTabs() {
	const tabsBlocks = document.querySelectorAll( '[data-tabs-block]' );

	if ( ! tabsBlocks.length ) {
		return;
	}

	tabsBlocks.forEach( ( block ) => {
		const tabButtons = block.querySelectorAll( '.tabs-block__tab-button' );
		const tabPanels = block.querySelectorAll( '.tabs-block__panel' );

		if ( ! tabButtons.length || ! tabPanels.length ) {
			return;
		}

		tabButtons.forEach( ( button ) => {
			button.addEventListener( 'click', () => {
				const tabIndex = parseInt( button.getAttribute( 'data-tab-index' ), 10 );

				// Remove active state from all buttons
				tabButtons.forEach( ( btn ) => {
					btn.setAttribute( 'aria-selected', 'false' );
					btn.classList.remove( 'border-orange', 'text-orange' );
					btn.classList.add( 'border-transparent', 'text-gray-700' );
				} );

				// Hide all panels
				tabPanels.forEach( ( panel ) => {
					panel.classList.add( 'hidden' );
				} );

				// Activate clicked button
				button.setAttribute( 'aria-selected', 'true' );
				button.classList.remove( 'border-transparent', 'text-gray-700' );
				button.classList.add( 'border-orange', 'text-orange' );

				// Show corresponding panel
				const targetPanel = block.querySelector(
					`.tabs-block__panel[data-panel-index="${ tabIndex }"]`
				);
				if ( targetPanel ) {
					targetPanel.classList.remove( 'hidden' );
				}
			} );
		} );
	} );
}

